var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.666 16.5003L15.0232 11.0003M9.30887 11.0003L2.66605 16.5003M2.16602 6.41699L10.3309 11.6561C10.9921 12.0804 11.3227 12.2925 11.6823 12.3747C11.9999 12.4473 12.3321 12.4473 12.6498 12.3747C13.0093 12.2925 13.3399 12.0804 14.0011 11.6561L22.166 6.41699M6.96602 18.3337H17.366C19.0462 18.3337 19.8863 18.3337 20.528 18.0339C21.0925 17.7703 21.5514 17.3496 21.839 16.8321C22.166 16.2439 22.166 15.4738 22.166 13.9337V8.06699C22.166 6.52685 22.166 5.75678 21.839 5.16852C21.5514 4.65107 21.0925 4.23038 20.528 3.96672C19.8863 3.66699 19.0462 3.66699 17.366 3.66699H6.96602C5.28586 3.66699 4.44578 3.66699 3.80404 3.96672C3.23956 4.23038 2.78062 4.65107 2.493 5.16852C2.16602 5.75678 2.16602 6.52685 2.16602 8.06699V13.9337C2.16602 15.4738 2.16602 16.2439 2.493 16.8321C2.78062 17.3496 3.23956 17.7703 3.80404 18.0339C4.44578 18.3337 5.28586 18.3337 6.96602 18.3337Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail02);
export default __webpack_public_path__ + "static/media/mail-02.f8d059e03cfa7456fc8d861fc34b2d19.svg";
export { ForwardRef as ReactComponent };